export default "__VITE_ASSET__BWi09mHK__"